<template>
  <AppHeading
    as="h3"
    size="xl"
    color="primaryBlack"
    weight="semibold"
    data-header
  >
    {{ t('chat.aiAgent.followUp') }}
  </AppHeading>

  <div v-for="question in questions" :key="question">
    <el-divider class="tw-my-2" />

    <el-row align="middle" justify="space-between" class="tw-flex-nowrap">
      <AppText color="primaryBlack" weight="semibold" data-text>
        {{ question }}
      </AppText>
      <AppButton
        text
        circle
        data-follow
        :disabled="disabled"
        only-icon
        @click="handleClick(question)"
      >
        <AppIcon shape="send" color="primaryBlack" size="16" />
      </AppButton>
    </el-row>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { MessageType } from '@protos/chat/message_type_pb'

import { useChatMessages } from '@pc/composables/use-chat-messages'

defineProps<{
  questions: string[]
  disabled?: boolean
}>()

const { t } = useI18n()

const { sendUserMessage } = useChatMessages()

const handleClick = (text: string) => {
  sendUserMessage({
    files: [],
    message: {
      text,
      attachments: [],
      messageType: MessageType.TEXT,
    },
    isMessageToAIAgent: true,
  })
}
</script>
